import { AgGridReact } from "@jsq/ds/core";
export const colDefs: AgGridReact.AgGridReactProps["columnDefs"] = [
  {
    field: "batchDate",
    headerName: "Transfer date",
    sortable: false,
    maxWidth: 150,
  },
  {
    field: "description",
    headerName: "Description",
    sortable: false,
    minWidth: 400,
  },
  {
    field: "syncedBy",
    headerName: "Synced by",
    width: 340,
  },
];

export const gridOptions: AgGridReact.AgGridReactProps["gridOptions"] = {
  autoSizeStrategy: {
    type: "fitGridWidth",
  },
  suppressCellFocus: true,
  rowHeight: 42,
  domLayout: "autoHeight",
  pagination: true,
  paginationPageSize: 15,
  paginationPageSizeSelector: false,
};

export type Row = {
  batchDate: string;
  description: string;
  syncedBy: string;
};

export const getRowData = (data: Row[]) => {
  return data.map((row) => {
    return {
      ...row,
      syncedBy: row.syncedBy,
      description: row.description,
    };
  });
};
